export default "__VITE_ASSET__d82d00eb__"